import { createContext } from "react";
import type { Dayjs } from "dayjs";

export interface CustomMarker {
  id: string;
  name: string;
  date: Dayjs | null;
  latitude: string;
  longitude: string;
  description: string;
}

export interface CustomMarkerGroup {
  id: number;
  name: string;
  color: string;
  visible?: boolean;
  markers: CustomMarker[];
}

export type CustomMarkersContextValue = {
  groups: CustomMarkerGroup[];
  addGroup: () => void;
  removeGroup: (groupId: number) => void;
  updateGroupName: (groupId: number, name: string) => void;
  updateGroupColor: (groupId: number, color: string) => void;
  addMarker: (groupId: number) => void;
  removeMarker: (groupId: number, markerId: string) => void;
  updateMarker: <K extends keyof CustomMarker>(
    groupId: number,
    markerId: string,
    key: K,
    value: CustomMarker[K],
  ) => void;
  setGroupVisible: (groupId: number, visible: boolean) => void;
  importGroups: (groups: CustomMarkerGroup[]) => void;
  clearGroups: () => void;
};

export const CustomMarkersContext = createContext<
  CustomMarkersContextValue | undefined
>(undefined);
